import { Component, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@otas/modal/modal';
import { AppConstants } from '../../app.constants';
import { MemberList, MemberRequest, MemberType, TempleMember } from '@otas/stoda/model/member/member';
import { Observable } from 'rxjs';
import { GenericResponse } from '@otas/model/genericResponse';
import * as _ from 'underscore';
@Injectable()
export class AddMemberModalService {
    constructor(private http: HttpClient, public modalService: NgbModal) { }
    openModalForAddMember(component: Component, data, flag, typeId) {
        const modalRef = this.modalService.open(component, AppConstants.largeModaloptions);
        modalRef.componentInstance.data = data;
        modalRef.componentInstance.flag = flag;
        modalRef.componentInstance.typeWiseMemberId = typeId;
        return modalRef;
    }
    saveMember(request: MemberRequest, file: File): Observable<GenericResponse<TempleMember>> {
        const formdata: FormData = new FormData();
        const datalob = new Blob([JSON.stringify(request)], {
            type: 'application/json',
        });
        formdata.append('request', datalob);
        formdata.append('file', file);
        return this.http.post<GenericResponse<TempleMember>>(`member`, formdata);
    }
    updateMember(request: MemberRequest, file: File): Observable<GenericResponse<TempleMember>> {
        const formdata: FormData = new FormData();
        const datalob = new Blob([JSON.stringify(request)], {
            type: 'application/json',
        });
        formdata.append('request', datalob);
        formdata.append('file', file);
        return this.http.put<GenericResponse<TempleMember>>(`member/${request.id}`, formdata);
    }
    getAllMemberType(): Observable<any> {
        return this.http.get<any>(`membertype`);
    }
    submitMemberType(data, prefix): Observable<GenericResponse<string>> {
        return this.http.post<GenericResponse<string>>(`membertype/${data}/${prefix}`, null);
    }
    getMembers(): Observable<GenericResponse<MemberList>> {
       
        // tslint:disable-next-line:max-line-length
        return this.http.get<GenericResponse<MemberList>>(`member/type/report`);
      }
}
